import { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import getGqlClient from '@spotahome/marketplace-common/src/graphql/client';
import getReviews from '@spotahome/marketplace-common/src/graphql/queries/reviews';

import { ListingSectionObservable } from '../ListingSection';
import ListingTitle from '../ListingTitle';

import './Reviews.scss';
import Average from './Average';
import ReviewsFactors from './ReviewsFactors';
import ListingReviews from './ListingReviews';

const Reviews = ({ reference }) => {
  const [reviews, setReviews] = useState([]);
  const [average, setAverage] = useState([]);
  const [totalAverage, setTotalAverage] = useState(0);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await getReviews(getGqlClient())(reference);
        const data = response?.data?.reviews;
        if (data) {
          setReviews(data.reviews || []);
          setAverage(data.average || []);
          setTotalAverage(data.totalAverage || 0);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchReviews();
  }, [reference]);

  return (
    <ListingSectionObservable section="reviews">
      <ListingTitle role="secondary">
        {trans('listing.reviews.title')}
      </ListingTitle>
      <div id="reviews">
        {!!totalAverage && (
          <Fragment>
            <Average
              ratingAverage={Math.round(totalAverage)}
              count={reviews.length}
            />
            <ReviewsFactors factors={average} />
          </Fragment>
        )}
        <ListingReviews reviews={reviews} />
      </div>
    </ListingSectionObservable>
  );
};

Reviews.propTypes = {
  reference: PropTypes.string.isRequired
};

export default Reviews;
